import { useRef, useEffect, useState, useCallback } from 'react';
import { cn } from '../lib/utils';

export function InfiniteSlider({
  children,
  gap = 42,
  speed = 80,
  speedOnHover = 25,
  reverse = false,
  className,
}) {
  const scrollRef = useRef(null);
  const innerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  // Calculate animation duration based on content width and speed
  const [duration, setDuration] = useState(20);

  const measure = useCallback(() => {
    if (!innerRef.current) return;
    const contentWidth = innerRef.current.scrollWidth / 2; // half because we duplicate
    setDuration(contentWidth / speed);
  }, [speed]);

  useEffect(() => {
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [measure, children]);

  const currentSpeed = isHovered ? (duration * speed) / speedOnHover : duration;

  return (
    <div
      ref={scrollRef}
      className={cn('overflow-hidden', className)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        ref={innerRef}
        className="flex w-max"
        style={{
          gap: `${gap}px`,
          animation: `infinite-scroll ${currentSpeed}s linear infinite`,
          animationDirection: reverse ? 'reverse' : 'normal',
        }}
      >
        {children}
        {/* Duplicate for seamless loop */}
        {children}
      </div>

      <style>{`
        @keyframes infinite-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
